import {
  WorkspaceMemberStatus,
  type WorkspaceMemberWithUserDto,
} from '@up2stay/up2promo-api-client';

import { getAbsoluteFileUrl } from '@/core/lib/file-url';

export function workspaceMemberDisplayName(
  member: WorkspaceMemberWithUserDto,
): string {
  const uid = member.userId?.trim() ?? '';
  const u = member.user;
  if (!u) return uid;
  const name = `${u.firstName ?? ''} ${u.lastName ?? ''}`.trim();
  return name || u.email || u.username || uid;
}

export function workspaceMemberSecondaryLine(
  member: WorkspaceMemberWithUserDto,
): string | null {
  const u = member.user;
  if (!u?.email) return null;
  const name = `${u.firstName ?? ''} ${u.lastName ?? ''}`.trim();
  if (name && u.email) return u.email;
  return null;
}

export function workspaceMemberInitials(
  member: WorkspaceMemberWithUserDto,
): string {
  const label = workspaceMemberDisplayName(member);
  if (!label) return '?';
  const parts = label.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0]![0] ?? ''}${parts[1]![0] ?? ''}`.toUpperCase();
  }
  return label.slice(0, 2).toUpperCase();
}

export function workspaceMemberAvatarUrl(
  member: WorkspaceMemberWithUserDto,
): string | null {
  const path = member.user?.photo?.path?.trim();
  if (!path) return null;
  return getAbsoluteFileUrl(path);
}

export function isActiveWorkspaceMember(
  member: WorkspaceMemberWithUserDto,
): boolean {
  const s = member.status;
  if (s === WorkspaceMemberStatus.ACTIVE) return true;
  if (String(s ?? '').toLowerCase() === 'active') return true;
  if (s === undefined || s === null) return !!member.userId?.trim();
  return false;
}
